(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-chapters"] && !Shopify.designMode) return;
  try {
    
  class AboutChapters extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
      this.triggers = this.querySelectorAll('.chapter__trigger');
      this.measureFooter();
    }

    disconnectedCallback() {
      if (this.footerObserver) this.footerObserver.disconnect();
    }

    measureFooter() {
      // Try common Baseline / Shopify footer selectors in order of specificity
      const footer =
        document.querySelector('.shopify-section-group-footer-group') ||
        document.querySelector('footer.cl-footer')?.closest('.shopify-section') ||
        document.querySelector('footer');

      if (!footer) return;

      const update = () => {
        const height = footer.getBoundingClientRect().height;
        this.style.setProperty('--footer-height', `${height}px`);
      };

      update();

      if (window.ResizeObserver) {
        this.footerObserver = new ResizeObserver(update);
        this.footerObserver.observe(footer);
      } else {
        window.addEventListener('resize', update);
      }
    }

    handleClick(event) {
      // Gallery nav buttons get their own behavior
      const galleryBtn = event.target.closest('[data-direction]');
      if (galleryBtn) {
        event.stopPropagation();
        this.scrollGallery(galleryBtn);
        return;
      }

      const chapter = event.target.closest('.chapter');
      if (!chapter) return;

      // If the chapter is already active, let normal interactions through
      // (links inside rte, video controls, etc.)
      if (chapter.dataset.active === 'true') return;

      // Otherwise activate this chapter
      this.activateChapter(chapter);
    }

    activateChapter(chapter) {
      this.querySelectorAll('.chapter[data-active="true"]').forEach((c) => {
        c.dataset.active = 'false';
        const trigger = c.querySelector('.chapter__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        c.querySelectorAll('video').forEach((v) => v.pause());
      });

      chapter.dataset.active = 'true';
      const trigger = chapter.querySelector('.chapter__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      chapter.querySelectorAll('video').forEach((v) => {
        const playPromise = v.play();
        if (playPromise !== undefined) playPromise.catch(() => {});
      });
    }

    scrollGallery(btn) {
      const media = btn.closest('.chapter__media');
      if (!media) return;
      const gallery = media.querySelector('[data-gallery]');
      if (!gallery) return;

      const firstItem = gallery.firstElementChild;
      const itemWidth = firstItem ? firstItem.clientWidth : gallery.clientWidth;
      const delta = btn.dataset.direction === 'next' ? itemWidth : -itemWidth;

      gallery.scrollBy({ left: delta, behavior: 'smooth' });
    }

    handleKeydown(event) {
      const trigger = event.target.closest('.chapter__trigger');
      if (!trigger) return;

      const navKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!navKeys.includes(event.key)) return;

      event.preventDefault();
      const triggers = Array.from(this.triggers);
      const currentIndex = triggers.indexOf(trigger);
      let nextIndex = currentIndex;

      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = currentIndex > 0 ? currentIndex - 1 : triggers.length - 1;
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = currentIndex < triggers.length - 1 ? currentIndex + 1 : 0;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = triggers.length - 1;
          break;
      }

      triggers[nextIndex].focus();
      const targetChapter = triggers[nextIndex].closest('.chapter');
      if (targetChapter) this.activateChapter(targetChapter);
    }
  }

  if (!customElements.get('about-chapters')) {
    customElements.define('about-chapters', AboutChapters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-care"] && !Shopify.designMode) return;
  try {
    
  class CustomerCare extends HTMLElement {
    connectedCallback() {
      this.triggers = this.querySelectorAll('[data-cc-trigger]');
      this.mobileTriggers = this.querySelectorAll('[data-cc-mobile-trigger]');
      this.panels = this.querySelectorAll('.customer-care__panel');

      this.triggers.forEach((t) => t.addEventListener('click', this.handleDesktopClick.bind(this)));
      this.mobileTriggers.forEach((t) => t.addEventListener('click', this.handleMobileClick.bind(this)));
      this.addEventListener('keydown', this.handleKeydown.bind(this));

      const initialHandle = this.resolveInitialActive();
      if (initialHandle) this.activate(initialHandle, { scroll: false, updateHash: false });

      window.addEventListener('hashchange', this.handleHashChange.bind(this));
      this.measureFooter();
    }

    disconnectedCallback() {
      if (this.footerObserver) this.footerObserver.disconnect();
    }

    measureFooter() {
      const footer =
        document.querySelector('.shopify-section-group-footer-group') ||
        document.querySelector('footer.cl-footer')?.closest('.shopify-section') ||
        document.querySelector('footer');

      if (!footer) return;

      const update = () => {
        const height = footer.getBoundingClientRect().height;
        this.closest('.customer-care')?.style.setProperty('--footer-height', `${height}px`);
      };

      update();

      if (window.ResizeObserver) {
        this.footerObserver = new ResizeObserver(update);
        this.footerObserver.observe(footer);
      } else {
        window.addEventListener('resize', update);
      }
    }

    resolveInitialActive() {
      const hash = window.location.hash.replace('#', '');
      if (hash) {
        const match = Array.from(this.panels).find((p) => p.dataset.ccPanel === hash);
        if (match) return match.dataset.ccPanel;
      }
      const defaultOpen = this.dataset.defaultOpen;
      if (defaultOpen === 'none') return null;
      return this.panels[0] ? this.panels[0].dataset.ccPanel : null;
    }

    handleDesktopClick(event) {
      const trigger = event.currentTarget;
      const target = trigger.dataset.target;
      if (!target) return;
      this.activate(target, { scroll: true, updateHash: true });
    }

    activate(handle, options = {}) {
      const { scroll = false, updateHash = true } = options;

      this.panels.forEach((panel) => {
        panel.dataset.active = panel.dataset.ccPanel === handle ? 'true' : 'false';
      });
      this.triggers.forEach((trigger) => {
        trigger.setAttribute('aria-current', trigger.dataset.target === handle ? 'true' : 'false');
      });

      if (updateHash && window.history && window.history.replaceState) {
        try { window.history.replaceState(null, '', '#' + handle); } catch (e) {}
      }

      if (scroll && window.innerWidth >= 1024) {
        const active = this.querySelector('.customer-care__panel[data-active="true"]');
        if (active) {
          const rect = active.getBoundingClientRect();
          if (rect.top < 0 || rect.top > window.innerHeight * 0.5) {
            active.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    }

    handleMobileClick(event) {
      const trigger = event.currentTarget;
      const panel = trigger.closest('.customer-care__panel');
      if (!panel) return;
      const isOpen = panel.dataset.mobileOpen === 'true';
      panel.dataset.mobileOpen = isOpen ? 'false' : 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }

    handleHashChange() {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return;
      const match = Array.from(this.panels).find((p) => p.dataset.ccPanel === hash);
      if (match) this.activate(match.dataset.ccPanel, { scroll: true, updateHash: false });
    }

    handleKeydown(event) {
      const trigger = event.target.closest('[data-cc-trigger]');
      if (!trigger) return;
      const navKeys = ['ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!navKeys.includes(event.key)) return;

      event.preventDefault();
      const triggers = Array.from(this.triggers);
      const currentIndex = triggers.indexOf(trigger);
      let nextIndex = currentIndex;

      switch (event.key) {
        case 'ArrowUp':
          nextIndex = currentIndex > 0 ? currentIndex - 1 : triggers.length - 1;
          break;
        case 'ArrowDown':
          nextIndex = currentIndex < triggers.length - 1 ? currentIndex + 1 : 0;
          break;
        case 'Home': nextIndex = 0; break;
        case 'End': nextIndex = triggers.length - 1; break;
      }

      triggers[nextIndex].focus();
      triggers[nextIndex].click();
    }
  }

  if (!customElements.get('customer-care')) {
    customElements.define('customer-care', CustomerCare);
  }

  class CustomerCareQA extends HTMLElement {
    constructor() {
      super();
      this.isAnimating = false;
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.customer-care__qa-panel');
      if (!this.details || !this.summary || !this.panel) return;
      if (this.details.open) this.classList.add('is-open');
      this.summary.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();
      if (this.isAnimating) return;
      if (this.classList.contains('is-open')) this.collapse();
      else this.expand();
    }

    expand() {
      this.isAnimating = true;
      this.details.open = true;
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.afterTransition();
      });
    }

    collapse() {
      this.isAnimating = true;
      this.classList.remove('is-open');
      this.afterTransition(() => { this.details.open = false; });
    }

    afterTransition(callback) {
      const done = () => {
        this.panel.removeEventListener('transitionend', onEnd);
        clearTimeout(timeout);
        this.isAnimating = false;
        if (callback) callback();
      };
      const onEnd = (event) => {
        if (event.target !== this.panel) return;
        if (event.propertyName !== 'grid-template-rows') return;
        done();
      };
      const timeout = setTimeout(done, 600);
      this.panel.addEventListener('transitionend', onEnd);
    }
  }

  if (!customElements.get('customer-care-qa')) {
    customElements.define('customer-care-qa', CustomerCareQA);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xj-collection-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('xj-collection-carousel')) return;

  const ENTER_MS = 1100;   // matches --xj-cc-enter
  const STAGGER_MS = 90;   // delay between cards dealing in
  const LEAVE_MS = 320;    // collection switch fade-out
  const SPREAD_MS = 900;   // matches --xj-cc-spread
  const TIGHT_RATIO = 0.3; // entrance gap as a share of the final gap
  const mod = (a, n) => ((a % n) + n) % n;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* One carousel per collection panel */
  class Lane {
    constructor(root, panel) {
      this.root = root;
      this.panel = panel;
      this.viewport = panel.querySelector('[data-viewport]');
      this.track = panel.querySelector('[data-track]');
      this.dots = Array.from(panel.querySelectorAll('[data-dot]'));
      this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
      this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
      this.realCount = this.slides.length;
      this.isStatic = this.realCount < 2;
      if (!this.isStatic) this.fillLoop();
      this.n = this.slides.length;
      this.slides.forEach((s, i) => { s._i = i; s._off = 0; });
      this.active = 0;
      this.entered = false;
      this.timers = [];
      this.enterToken = 0;
      this.W = 0;
    }

    /* Short collections get cloned so the loop never shows a gap */
    fillLoop() {
      const min = Math.ceil(this.root.maxVisible) + 3;
      const originals = this.slides.slice();
      for (let k = 0; this.slides.length < min; k++) {
        const clone = originals[k % originals.length].cloneNode(true);
        clone.setAttribute('data-clone', '');
        this.track.appendChild(clone);
        this.slides.push(clone);
      }
    }

    measure() {
      const W = this.viewport.clientWidth;
      if (!W) return false;
      const v = this.root.visibleCount();
      const gap = this.root.gap;
      const s = this.root.restScale;
      this.W = W;
      this.s = s;
      // Row = one full-size center card + (v - 1) side cards at rest scale + gaps
      this.cardW = Math.max(140, (W - gap * (v - 1)) / (1 + (v - 1) * s));
      this.step = s * this.cardW + gap;                // side card to side card
      this.near = (this.cardW * (1 + s)) / 2 + gap;    // center card to first neighbour
      this.tightStep = s * this.cardW + Math.min(gap, Math.max(2, gap * TIGHT_RATIO));
      this.half = Math.ceil((v - 1) / 2); // how many cards are (partly) visible each side
      this.track.style.setProperty('--xj-cc-card-w', `${this.cardW.toFixed(2)}px`);
      return true;
    }

    offsetOf(i) {
      const h = Math.floor(this.n / 2);
      return mod(i - this.active + h, this.n) - h;
    }

    /* Visible gaps stay equal: the center card is wider, so its neighbours sit further out.
       "tight" = the entrance layout: everyone at rest scale with a narrow gap. */
    xFor(off, tight = false) {
      let c = 0;
      if (off !== 0) {
        const step = tight ? this.tightStep : this.step;
        const first = tight ? this.tightStep : this.near;
        c = Math.sign(off) * (first + (Math.abs(off) - 1) * step);
      }
      return (this.W - this.cardW) / 2 + c;
    }

    place(slide, off, tight = false) {
      slide.style.setProperty('--x', `${this.xFor(off, tight).toFixed(2)}px`);
    }

    instantly(fn) {
      this.track.classList.add('is-instant');
      fn();
      void this.track.offsetWidth;
      this.track.classList.remove('is-instant');
    }

    syncState() {
      const realActive = this.active % this.realCount;
      this.slides.forEach((s, i) => {
        const off = this.offsetOf(i);
        const hidden = Math.abs(off) > this.half;
        s.toggleAttribute('inert', hidden);
        s.setAttribute('aria-hidden', String(hidden));
        s.classList.toggle('is-active', this.entered && off === 0);
      });
      this.dots.forEach((d, i) => {
        const on = i === realActive;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    render(instant = false) {
      const apply = () => this.slides.forEach((s, i) => {
        const off = this.offsetOf(i);
        this.place(s, off);
        s._off = off;
      });
      if (instant) this.instantly(apply);
      else apply();
      this.syncState();
    }

    goTo(target, announce = true) {
      if (this.isStatic) return;
      const n = this.n;
      target = mod(target, n);
      let d = mod(target - this.active, n);
      if (d > n / 2) d -= n;
      this.stopEnter();
      if (d === 0) {
        this.track.style.setProperty('--drag', '0px');
        this.syncState();
        return;
      }
      this.active = target;

      // Cards that wrap around the loop jump (unseen, off-screen) to where they'd be
      // on an endless strip, so every card then slides the same distance.
      const jumpers = [];
      this.slides.forEach((s, i) => {
        const off = this.offsetOf(i);
        if (off + d !== s._off) {
          s.classList.add('is-jump');
          this.place(s, off + d);
          jumpers.push(s);
        }
      });
      if (jumpers.length) {
        void this.track.offsetWidth;
        jumpers.forEach((s) => s.classList.remove('is-jump'));
      }
      this.track.style.setProperty('--drag', '0px');
      this.render();
      if (announce) this.root.announce(this);
    }

    goToReal(r) {
      let best = this.active;
      let bestD = Infinity;
      for (let i = r; i < this.n; i += this.realCount) {
        let d = mod(i - this.active, this.n);
        if (d > this.n / 2) d -= this.n;
        if (Math.abs(d) < bestD) { bestD = Math.abs(d); best = i; }
      }
      this.goTo(best);
    }

    /* Pre-state: visible cards parked just past the right edge, invisible */
    prepare() {
      this.stopEnter();
      this.entered = false;
      this.park();
    }

    park() {
      if (!this.measure()) return;
      this.track.classList.add('is-pre');
      const parkX = `${(this.W + this.step * 0.25).toFixed(2)}px`;
      this.instantly(() => {
        this.slides.forEach((s, i) => {
          const off = this.offsetOf(i);
          s._off = off;
          if (Math.abs(off) <= this.half) s.style.setProperty('--x', parkX);
          else this.place(s, off);
        });
      });
      this.syncState();
    }

    warm() {
      const imgs = Array.from(this.track.querySelectorAll('img'));
      imgs.forEach((img) => { img.loading = 'eager'; });
      const visible = this.slides
        .filter((s, i) => Math.abs(this.offsetOf(i)) <= this.half)
        .flatMap((s) => Array.from(s.querySelectorAll('img')));
      const ready = Promise.all(visible.map((img) =>
        (img.complete ? Promise.resolve() : img.decode()).catch(() => {})));
      return Promise.race([ready, new Promise((r) => setTimeout(r, 700))]);
    }

    enter() {
      if (!this.measure()) return;
      if (this.isStatic || reduceMotion.matches) {
        this.stopEnter();
        this.entered = true;
        this.render(true);
        this.warm();
        return;
      }
      this.prepare();
      const token = this.enterToken;
      this.warm().then(() => { if (token === this.enterToken) this.play(); });
    }

    play() {
      const order = this.slides
        .map((s, i) => ({ s, off: this.offsetOf(i) }))
        .filter((o) => Math.abs(o.off) <= this.half)
        .sort((a, b) => a.off - b.off); // left-most card leaves first

      // 1. Deal in from the right into a tight row
      this.track.classList.add('is-entering');
      this.track.classList.remove('is-pre');
      order.forEach(({ s, off }, k) => {
        s.style.setProperty('--enter-delay', `${k * STAGGER_MS}ms`);
        this.place(s, off, true);
      });

      // 2. As the row settles, the gaps widen and the center card grows together
      const settle = (order.length - 1) * STAGGER_MS + ENTER_MS * 0.65;
      this.timers.push(setTimeout(() => {
        this.track.classList.remove('is-entering');
        this.track.classList.add('is-spreading');
        this.entered = true;
        this.render();
        this.timers.push(setTimeout(() => this.track.classList.remove('is-spreading'), SPREAD_MS + 100));
      }, settle));
    }

    stopEnter() {
      this.enterToken++;
      this.timers.forEach(clearTimeout);
      this.timers = [];
      const cl = this.track.classList;
      cl.remove('is-spreading');
      if (cl.contains('is-entering') || cl.contains('is-pre')) {
        cl.remove('is-entering', 'is-pre');
        this.entered = true;
      }
    }

    leave() {
      this.stopEnter();
      this.track.classList.add('is-leaving');
    }

    reset() {
      this.stopEnter();
      this.track.classList.remove('is-leaving');
      this.track.style.setProperty('--drag', '0px');
      this.active = 0;
      this.entered = false;
    }
  }

  class XjCollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.panels.length) return;

      this.abort = new AbortController();
      this.gap = parseFloat(this.dataset.gap) || 0;
      this.restScale = parseFloat(this.dataset.restScale) || 0.88;
      this.vDesktop = parseFloat(this.dataset.visibleDesktop) || 5;
      this.vTablet = parseFloat(this.dataset.visibleTablet) || 3;
      this.vMobile = parseFloat(this.dataset.visibleMobile) || 1.4;
      this.maxVisible = Math.max(this.vDesktop, this.vTablet, this.vMobile);
      this.mqDesktop = window.matchMedia('(min-width: 1024px)');
      this.mqTablet = window.matchMedia('(min-width: 750px)');

      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.statusEl = this.querySelector('[data-status]');
      this.arrows = this.querySelector('[data-arrows]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.lanes = this.panels.map((p) => new Lane(this, p));
      this.current = Math.max(0, this.panels.findIndex((p) => !p.hidden));
      this.switchToken = 0;
      this.started = false;

      this.classList.add('is-ready');
      this.bindControls();
      this.lanes.forEach((lane) => this.bindPointer(lane));
      this.updateControls();
      this.lane.prepare();
      this.watchVisibility();
      this.watchSize();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.io?.disconnect();
      this.nearIo?.disconnect();
      this.ro?.disconnect();
      this.lanes?.forEach((l) => l.stopEnter());
      clearTimeout(this.swapTimer);
    }

    get lane() { return this.lanes[this.current]; }

    visibleCount() {
      if (this.mqDesktop.matches) return this.vDesktop;
      if (this.mqTablet.matches) return this.vTablet;
      return this.vMobile;
    }

    /* Public: lets you re-run the entrance (handy in the theme editor) */
    replay() {
      this.lane.reset();
      this.lane.enter();
    }

    start() {
      if (this.started) return;
      this.started = true;
      this.lane.enter();
      // Warm the other collections once the first has played
      setTimeout(() => this.lanes.forEach((l) => {
        l.track.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      }), ENTER_MS + 800);
    }

    watchVisibility() {
      if (!('IntersectionObserver' in window)) { this.start(); return; }
      this.nearIo = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.nearIo.disconnect(); this.lane.warm(); }
      }, { rootMargin: '0px 0px 600px 0px' });
      this.nearIo.observe(this);
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.start(); }
      }, { threshold: 0.3 });
      this.io.observe(this.lane.viewport);
    }

    watchSize() {
      let lastW = this.lane.viewport.clientWidth; // ignore the observer's initial call
      let raf = 0;
      this.ro = new ResizeObserver(() => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const lane = this.lane;
          const w = lane.viewport.clientWidth;
          if (!w || w === lastW) return;
          lastW = w;
          if (lane.track.classList.contains('is-pre')) lane.park(); // keeps a pending entrance alive
          else { lane.measure(); lane.render(true); }
        });
      });
      this.ro.observe(this);
    }

    bindControls() {
      const { signal } = this.abort;
      this.prevBtn?.addEventListener('click', () => this.lane.goTo(this.lane.active - 1), { signal });
      this.nextBtn?.addEventListener('click', () => this.lane.goTo(this.lane.active + 1), { signal });

      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.select(i), { signal }));
      this.querySelector('[role="tablist"]')?.addEventListener('keydown', (e) => {
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0) return;
        const last = this.tabs.length - 1;
        const next = { ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last }[e.key];
        if (next === undefined) return;
        e.preventDefault();
        this.tabs[next].focus();
        this.select(next);
      }, { signal });

      this.lanes.forEach((lane) => lane.dots.forEach((dot, di) => {
        dot.addEventListener('click', () => lane.goToReal(di), { signal });
      }));

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (!e.target.closest('[data-viewport], [data-arrows], [data-dots]')) return;
        e.preventDefault();
        this.lane.goTo(this.lane.active + (e.key === 'ArrowRight' ? 1 : -1));
      }, { signal });

      // Theme editor: selecting a block opens its collection
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.panels.findIndex((p) => p.dataset.blockId === e.detail?.blockId);
        if (i > -1) this.select(i, true);
      }, { signal });
    }

    bindPointer(lane) {
      const { signal } = this.abort;
      const vp = lane.viewport;
      let start = null;
      let dx = 0;
      let dragging = false;
      let suppressClick = false;

      vp.addEventListener('pointerdown', (e) => {
        if (lane.isStatic || (e.pointerType === 'mouse' && e.button !== 0)) return;
        start = { x: e.clientX, y: e.clientY, id: e.pointerId };
        dx = 0;
        dragging = false;
      }, { signal });

      vp.addEventListener('pointermove', (e) => {
        if (!start || e.pointerId !== start.id) return;
        dx = e.clientX - start.x;
        const dy = e.clientY - start.y;
        if (!dragging) {
          if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) {
            if (Math.abs(dy) > 12) start = null; // vertical scroll wins
            return;
          }
          dragging = true;
          lane.stopEnter();
          lane.track.classList.add('is-dragging');
          try { vp.setPointerCapture(e.pointerId); } catch (_) { /* noop */ }
        }
        const limit = lane.step * 1.6;
        const clamped = Math.max(-limit, Math.min(limit, dx));
        lane.track.style.setProperty('--drag', `${(clamped * 0.9).toFixed(1)}px`);
      }, { signal });

      const end = () => {
        if (!start) return;
        start = null;
        if (!dragging) return;
        dragging = false;
        suppressClick = true;
        setTimeout(() => { suppressClick = false; }, 0);
        lane.track.classList.remove('is-dragging');
        const dist = Math.min(Math.abs(dx), lane.step * 1.6);
        const steps = dist < 40 ? 0 : Math.max(1, Math.round(dist / lane.step));
        lane.goTo(lane.active + (dx < 0 ? steps : -steps));
      };
      vp.addEventListener('pointerup', end, { signal });
      vp.addEventListener('pointercancel', end, { signal });
      vp.addEventListener('dragstart', (e) => e.preventDefault(), { signal });

      // A click on a side card brings it to the center instead of following the link.
      // Keyboard activation (detail === 0) always follows the link.
      vp.addEventListener('click', (e) => {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; return; }
        const slide = e.target.closest('[data-slide]');
        if (!slide || lane.isStatic || e.detail === 0) return;
        if (slide._off !== 0) { e.preventDefault(); lane.goTo(slide._i); }
      }, { signal, capture: true });
    }

    select(i, immediate = false) {
      if (i === this.current || !this.panels[i]) return;
      const from = this.lane;
      const to = this.lanes[i];
      const token = ++this.switchToken;
      this.tabs.forEach((t, k) => {
        t.setAttribute('aria-selected', String(k === i));
        t.tabIndex = k === i ? 0 : -1;
      });

      const swap = () => {
        if (token !== this.switchToken) return;
        from.reset();
        from.panel.hidden = true;
        to.panel.hidden = false;
        this.current = i;
        this.updateControls();
        to.reset();
        if (this.started) to.enter();
        else to.prepare();
      };

      clearTimeout(this.swapTimer);
      if (immediate || reduceMotion.matches || !from.entered) { swap(); return; }
      from.leave();
      this.swapTimer = setTimeout(swap, LEAVE_MS);
    }

    updateControls() {
      const lane = this.lane;
      if (this.arrows) this.arrows.hidden = lane.isStatic;
      [this.prevBtn, this.nextBtn].forEach((b) => b?.setAttribute('aria-controls', lane.track.id));
    }

    announce(lane) {
      if (!this.statusEl) return;
      const slide = lane.slides[lane.active];
      const r = lane.active % lane.realCount;
      this.statusEl.textContent = `${slide.dataset.title || ''}, ${r + 1} / ${lane.realCount}`;
    }
  }

  customElements.define('xj-collection-carousel', XjCollectionCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
